import { NavigateOptions, useNavigate } from "@tanstack/react-router";
import { useUser } from "hooks/useUser.ts";

export const useTenantNavigate = () => {
    const navigate = useNavigate();
    const userUtils = useUser();

    return (to: string, options?: NavigateOptions) => {
        const activeTenant = userUtils.getActiveTenant();
        const tenantSlug = activeTenant?.slug_name;
        const target = "/$tenantSlug" + to;

        if (!tenantSlug) {
            throw Error("Undefined tenantSlug");
        }

        if (activeTenant) {
            navigate({
                // @TODO: ugly hotfix
                to: target as any,
                params: { tenantSlug },
                ...options,
            });
        }
    };
};
